/*
 * @Description: 
 * @Date: 2019-07-31 16:11:15
 */ 

import Vue from "vue";
import dateFormat from '@/tools/dateFormat';
import { twoDecimal } from '@/tools/money'
import { questionType } from '@/config/staticData';

Vue.filter("transDate", function(input) {
  if (typeof input == "number") {
    return dateFormat(input, 'YYYY-MM-DD');
  } else {
    return "无";
  }
});
Vue.filter("transMonth2", function(input) {
  if (typeof input == "number") {
    return dateFormat(input, 'YYYY-MM');
  } else {
    return "无";
  }
});
Vue.filter("transMonth", function(input) {
  if (typeof input == "number") {
    return dateFormat(input, 'MM月DD日 HH:mm');
  } else {
    return;
  }
});

Vue.filter("transAllTime", function(input,type = 'YYYY-MM-DD HH:mm:ss') {
  if (typeof input == "number") {
    return dateFormat(input, type)
  } else {
    return "";
  }
});
Vue.filter('transAllMin', function(input, type = 'YYYY-MM-DD HH:mm') {
  if (typeof input == 'number') {
    if (type === '-') {
      type = 'YYYY-MM-DD HH:mm';
    }
    return dateFormat(input, type);
  } else {
    return '-';
  }
});
//格式化 钱
Vue.filter('money', function (num) {
  const _num = twoDecimal(num, 100)
  return _num === '-' ? 0 : _num
});

//格式化 钱
Vue.filter('moneyFixed', function (num) {
  const _num = twoDecimal(num, 100, '元')
  return _num === '-' ? 0 : _num
});

Vue.filter("projectStatusFil", function(v) {
  if (v == 1) {
    return "已提交";
  } else {
    return "未提交";
  }
});
Vue.filter("transContractStatus", function(v) {
  //电子结算单状态
  if (v == 1) {
    return "无";
  } else if (v == 2) {
    return "待我签";
  } else if (v == 3) {
    return "带他签";
  }
});

Vue.filter('questionTypeLabelFil', function(val) {
  if (!val) return '';
  let { type, secondType, timeType } = val;
  secondType = secondType || timeType;
  if (typeof val === 'object') {
    if (questionType[type].children) {
      return (questionType[type].children[secondType] || { label: '' }).label;
    }
    return (questionType[type] || { label: '' }).label;
  }
  return (questionType[val] || { label: '' }).label;
});